import { InputLocation } from "./AppLocation";

export type LookupMap = Record<number, string>;

export type Location = {
    id: number;
    name: string;
    parentId?: number;
}

export type LocationDto = {
    locationId: number;
    locationName: string;
    locationTypeId: number;
    parentLocationId: number | null;
}
export type SaveLocationRequest = {
    locationId?: number; // omit for create
    locationName: string;
    locationTypeId: number;
    clientId: number | null;
    parentLocationId: number | null;
};

export type LocationType = {
    id: number;
    type: string;
    description: string;
}

export type LocationIndexes = {
    flatLocations: InputLocation[];
    locationLookup: LookupMap;
    nodeLookup: Record<number, InputLocation>;
};

export function flattenLocations(nodes: InputLocation[]): InputLocation[] {
    const result: InputLocation[] = [];

    const walk = (items: InputLocation[]) => {
        for (const item of items) {
            result.push(item);

            if (item.children?.length) {
                walk(item.children);
            }
        }
    };

    walk(nodes);
    return result;
}

export function buildLocationIndexes(locations: InputLocation[] | null | undefined): LocationIndexes {
    const safeLocations = Array.isArray(locations) ? locations : [];
    const flatLocations = flattenLocations(safeLocations);

    const locationLookup: LookupMap = Object.fromEntries(
        flatLocations
            .map(l => {
                const id = Number(l.id);
                const name = l.label ?? l.name ?? l.locationName ?? "";
                return [id, name];
            })
            .filter(([id, name]) => !Number.isNaN(id) && name)
    ) as LookupMap;

    const nodeLookup: Record<number, InputLocation> = {};

    for (const node of flatLocations) {
        const id = Number(node.id);
        const parentId = node.parentId != null ? Number(node.parentId) : null;
        const displayName = node.label ?? node.name ?? node.locationName ?? "";

        nodeLookup[id] = node;

        if (displayName) {
            locationLookup[id] = displayName;
        }
    }

    return {
        flatLocations,
        locationLookup,
        nodeLookup,
    };
}